import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import "./landing.css";

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import HowItWorks from "./components/HowItWorks";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQ from "./components/FAQ";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Enable smooth scrolling
    const setupScrolling = () => {
      // Set up smooth scrolling using GSAP
      gsap.config({
        nullTargetWarn: false,
      });

      // Clean up scroll triggers on component unmount
      return () => {
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      };
    };

    return setupScrolling();
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 text-white overflow-x-hidden">
      <Header onLoginClick={() => navigate("/login")} />

      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorks />
        <TestimonialsSection />
        <FAQ />
        <CTASection onLoginClick={() => navigate("/login")} onCompanyRegisterClick={() => navigate("/company-register")} />
      </main>

      <Footer />
    </div>
  );
}

export default LandingPage;
